module.exports = __webpack_public_path__ + "static/L2_content_text_meaning_4_dont-ca4eb0f6528a6bcf81d49169d78f7141.png";